import styled from "@emotion/styled"
import type { PIconProps, TextWeight } from "@porsche-design-system/components-react"
import { PText, PTextList, PTextListItem } from "@porsche-design-system/components-react"
import { spacingStaticXs } from "@porsche-design-system/components-react/emotion"
import { Visibility } from "@slfinrtl/ui-bff-routes"
import type { ListingVisibilityView } from "@slfinrtl/ui-bff-routes"
import { defineMessages, FormattedMessage } from "react-intl"
import { TagIcon } from "src/components/tagIcon/TagIcon"
import { Tooltip } from "src/components/tooltip/Tooltip"

interface VisibilityStatusProps {
	view: ListingVisibilityView
	weight?: TextWeight
}

const iconMap: Record<Visibility, PIconProps["name"]> = {
	[Visibility.INVALID]: "error",
	[Visibility.INVISIBLE]: "view-off",
	[Visibility.VISIBLE]: "view",
}

const messages = defineMessages({
	publishingRuleViolationsErrorHeading: {
		defaultMessage: "Please complete the following information so that the listing can be published:",
		id: "vehicleDetails.visibility.publishingRuleViolations.warning.heading",
	},
})

export const VisibilityStatus = ({ view, weight }: VisibilityStatusProps) => {
	const { displayText, violatedPublishingRules, visibility } = view
	return (
		<Tooltip
			content={
				violatedPublishingRules.length > 0 ? (
					<>
						<PText weight="semibold">
							<FormattedMessage {...messages.publishingRuleViolationsErrorHeading} />
						</PText>
						<PTextList>
							{violatedPublishingRules.map((v) => (
								<PTextListItem key={v}>{v}</PTextListItem>
							))}
						</PTextList>
					</>
				) : undefined
			}
		>
			<Wrapper>
				<StyledTagIcon
					color={visibility === Visibility.INVALID ? "error" : undefined}
					iconName={iconMap[visibility]}
				/>
				<PText weight={weight} ellipsis>
					{displayText}
				</PText>
			</Wrapper>
		</Tooltip>
	)
}

const Wrapper = styled.div`
	display: flex;
	gap: ${spacingStaticXs};
	justify-self: start; /* to center tooltip on actual content, not the available width */
`

const StyledTagIcon = styled(TagIcon)`
	margin: -3px 0;
`
